let BOTTOM_BAR_MENU = 'メニュー';
let BOTTOM_BAR_ORDER_LIST = '注文リスト';
let BOTTOM_BAR_ORDER_HISTORY = '注文履歴';

export default { BOTTOM_BAR_MENU, BOTTOM_BAR_ORDER_LIST, BOTTOM_BAR_ORDER_HISTORY };
